module.exports = __webpack_public_path__ + "static/media/news-4.a44aa2ae.jpg";